(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');
    module.directive('appointmentStateFilter', ['AgendaFilterBroadcast', '$filter', AppointmentStateFilterFn]);

    // filter directive for multiple appointment state selection
    function AppointmentStateFilterFn(AgendaFilterBroadcast, $filter) {
        var directive = {
            link: link,
            restrict: 'E',
            templateUrl: '/app/agenda/templates/appointment-state-filter.template.html',
            scope: {
                appointmentStates: '=',
                isPaid: '=',
                isVideoconsult: '=',
                filterDates: '='
            }
        };
        return directive;
        function link(scope, element, attrs) {
            // broadcast listener
            var listener = null;
            var listenerClear = null;

            // number of set filter
            scope.numFilters = 0;
            if (scope.isPaid === null || scope.isPaid === undefined ){
                scope.paidSelected = false;
                scope.notPaidSelected = false;
            }else {
                scope.paidSelected = scope.isPaid;
                scope.notPaidSelected = !scope.isPaid;
            }

            //activate directive
            activate();

            // filter state list
            scope.selectState = function ($event, state) {

                $event.stopPropagation();

                //reset
                scope.numFilters = 0;

                // role change
                if (state !== null) {
                    state.vmSelected = !state.vmSelected;
                }

                refresh();
            };
            
            scope.togglePaidSelected = function($event){
                $event.stopPropagation();
                scope.paidSelected = !scope.paidSelected;
                if (scope.notPaidSelected){
                    scope.notPaidSelected = false
                }
                setPaidScope();
            }

            scope.toggleNotPaidSelected = function($event){
                $event.stopPropagation();
                scope.notPaidSelected = !scope.notPaidSelected;
                if (scope.paidSelected){
                    scope.paidSelected = false
                }
                setPaidScope();
            }
            
            function setPaidScope(){
                if (scope.paidSelected)
                {
                    scope.isPaid = true;
                }else
                if (scope.notPaidSelected)
                {
                    scope.isPaid = false;
                }else{
                    scope.isPaid = null;
                }
            }

            // on destroy
            scope.$on('$destroy', function () {
                // unregister from broadcast
                if (listener) {
                    listener();
                    listener = null;
                }


                if (listenerClear) {
                    listenerClear();
                    listenerClear = null;
                }
            });

            // clear badge counts
            function clear() {
                //reset badge numbers
                for (var i = 0; i < scope.appointmentStates.length; i++) {
                    scope.appointmentStates[i].vmNumber = 0;
                } // for
                scope.paidSelected = false;
                scope.notPaidSelected = false;
                scope.isVideoconsult = false;

                setPaidScope();
            }


            // refresh view
            function refresh() {
                // number of selected states
                scope.numFilters = 0;
                for (var i = 0; i < scope.appointmentStates.length; i++) {
                    if (scope.appointmentStates[i].vmSelected) {
                        scope.numFilters++;
                    } //if
                }//for
            } // refresh

            // listen
            function listen() {
                //check for doing a refresh
                listener = scope.$on(AgendaFilterBroadcast.AppointmentStateRefresh, function () {
                    refresh();
                });

                listenerClear = scope.$on(AgendaFilterBroadcast.AppointmentStateClear, function () {
                    clear();
                });
            } // listen

            // init work
            function activate() {
                clear();
                // refresh view
                refresh();
                // listen
                listen();
            } //activate
        } // link
    }
})();